import apiFetch from '../apiFetch'

export default function (commentId, comment, token) {
  return apiFetch({ endPoint: `comment/${commentId}`, method: 'PUT', body: comment, token: token })
}
